import { storyblokEditable, StoryblokComponent } from "@storyblok/react/rsc";

import { Headline } from "@/components/typography/Headline";
import { RichTextField } from "@/components/typography/RichTextField";
import type { FeatureListCardStoryblok } from "@/component-types-sb";

type FeatureListCardProps = {
  blok: FeatureListCardStoryblok;
};

const FeatureListCard = ({ blok }: FeatureListCardProps) => (
  <section
    className="p-4 md:p-14 container max-w-7xl mx-auto"
    {...storyblokEditable(blok)}
  >
    <Headline as="h2">{blok.headline}</Headline>

    <RichTextField value={blok.text} className="text-copy max-w-4xl" />

    <div className="grid md:grid-cols-3 gap-4 lg:gap-8 pt-8">
      {blok?.items?.map((nestedBlok: any) => (
        <StoryblokComponent key={nestedBlok._uid} blok={nestedBlok} />
      ))}
    </div>
  </section>
);

export default FeatureListCard;
